import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { useIsMobile } from "@/hooks/use-mobile";
import { initSyncEngine } from "@/lib/syncEngine";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import MobileDashboard from "@/pages/MobileDashboard";
import CaptureEditor from "@/pages/CaptureEditor";
import SharePage from "@/pages/SharePage";
import InstallGuide from "@/pages/InstallGuide";
import TasksPage from "@/pages/TasksPage";
import SchedulePage from "@/pages/SchedulePage";
import GlobalNotePage from "@/pages/GlobalNotePage";
import AdminUsersPage from "@/pages/AdminUsersPage";

function App() {
  const isMobile = useIsMobile();
  useEffect(() => {
    initSyncEngine();
  }, []);
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/install" element={<InstallGuide />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  {isMobile ? <MobileDashboard /> : <Dashboard />}
                </ProtectedRoute>
              }
            />
            <Route
              path="/capture/:id"
              element={
                <ProtectedRoute>
                  <CaptureEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks"
              element={
                <ProtectedRoute>
                  <TasksPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/schedule"
              element={
                <ProtectedRoute>
                  <SchedulePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/global-note"
              element={
                <ProtectedRoute>
                  <GlobalNotePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <AdminUsersPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
